<script setup lang="ts">
import UiIcon from '@/components/core/UiIcon.vue';
import UiButton from '@/components/core/UiButton.vue';
import { computed, getCurrentInstance } from 'vue';
import { VueFinalModal, useVfm } from 'vue-final-modal';
import { useI18n } from 'vue-i18n';
import Icons from '@/constants/Icons';

const props = withDefaults(
  defineProps<{
    icon?: string;
    modalId?: string;
    required?: boolean;
    sizeClass?: string;
    title?: string;
  }>(),
  {
    modalId: getCurrentInstance()?.parent?.proxy?.$options.name || 'default-modal',
  },
);

const { t } = useI18n();
const { close } = useVfm();

const contentSizeClass = computed(() => ['relative rounded ui-bg-page shadow-lg', props.sizeClass]);
const computedTitle = computed(() => props.title || t('modalNames.' + props.modalId));
</script>

<template>
  <VueFinalModal
    :id="props.modalId"
    :modalId="props.modalId"
    :clickToClose="!props.required"
    :escToClose="!props.required"
    class="flex items-center justify-center"
    :contentClass="contentSizeClass"
    contentTransition="slide-fade-up"
    overlayTransition="vfm-fade"
  >
    <header
      class="ui-bg-primary relative flex min-h-16 items-center rounded-t px-2 py-2 shadow-lg"
      :class="props.required ? 'justify-center' : 'justify-between'"
    >
      <div class="flex items-center gap-2 px-2">
        <UiIcon v-if="props.icon" :path="props.icon" />
        <h2 class="ui-text-primary px-2 text-2xl font-medium">{{ computedTitle }}</h2>
      </div>
      <UiButton v-if="!props.required" :icon="Icons.Core.Close" @click="close(props.modalId)" />
    </header>
    <slot />
    <footer v-if="$slots.actions" class="ui-bg-secondary flex items-center justify-end gap-4 p-4">
      <slot name="actions" />
    </footer>
  </VueFinalModal>
</template>
